import { createGlobalStyle } from 'styled-components'
import { color } from 'styled-system'

export default createGlobalStyle`
  html {
    overflow-y: scroll;
  }  
    
  div {
    ${(props) => color({ ...props, color: 'neutrals.4' })};
  }

  h1, h2, h3, h4, h5, h6 {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: normal;
  }
`
